<template>
  <img
    :src="src"
    alt="tbi bank"
    :width="width"
    :height="height"
    class="tbi-logo"
    :class="[`tbi-logo--${size}`, `tbi-logo--${variant}`]"
    loading="lazy"
    decoding="async"
  >
</template>

<script setup lang="ts">
/**
 * Official tbi bank marks from https://tbibank.ro/
 * Brand accent: #FF6600
 */
const props = withDefaults(defineProps<{
  /** full wordmark | compact square mark */
  variant?: 'full' | 'mark'
  size?: 'sm' | 'md' | 'lg'
}>(), {
  variant: 'full',
  size: 'md',
})

const src = computed(() =>
  props.variant === 'mark'
    ? '/images/footer/tbi-logo-light.svg'
    : '/images/footer/tbi-logo.svg',
)

const dims = computed(() => {
  if (props.variant === 'mark') {
    if (props.size === 'sm') return { width: 20, height: 20 }
    if (props.size === 'lg') return { width: 32, height: 32 }
    return { width: 24, height: 24 }
  }
  if (props.size === 'sm') return { width: 72, height: 31 }
  if (props.size === 'lg') return { width: 101, height: 44 }
  return { width: 84, height: 37 }
})

const width = computed(() => dims.value.width)
const height = computed(() => dims.value.height)
</script>

<style scoped>
.tbi-logo {
  display: block;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.tbi-logo--full.tbi-logo--sm { height: 1.25rem; }
.tbi-logo--full.tbi-logo--md { height: 1.75rem; }
.tbi-logo--full.tbi-logo--lg { height: 2.25rem; }

.tbi-logo--mark.tbi-logo--sm { height: 1.25rem; width: 1.25rem; }
.tbi-logo--mark.tbi-logo--md { height: 1.5rem; width: 1.5rem; }
.tbi-logo--mark.tbi-logo--lg { height: 2rem; width: 2rem; }
</style>
